$(document).ready(function () {




    // Button Popup click
    $(".team-content__list .team-content__card .button-expand").each(function (index, element) {
        $(element).click(function () {
            $(element).addClass("opened");
            $('#popup-' + index).addClass("opened");
            $(".team-member-popup__list").addClass("opened");
        });
    });

    $(".team-content__popup .button-close").each(function (index, element) {
        $(element).click(function () {
            $(element).removeClass("opened");
            $('#popup-' + index).removeClass("opened");
            $(".team-member-popup__list").removeClass("opened");
        });
    });

    //button close


    // Show/hide mobile footer
    var footerNav = $('.footer-menu__item > ul > li .top-level-menu');
    footerNav.click(function (e) {
        $(this).next('ul').slideToggle();
        $(this).find('.expand-btn').text(function (i, text) {
            return text === "+" ? "-" : "+";
        });
        $(this).find('.expand-btn').toggleClass('expanded');

    });

});


